import {
  findOne as FindOneProduct
} from '@/repositories/integrations/mobly/services/csExternal/products'

const getUrlMainImages = async (data, organization) => {
  const product = await FindOneProduct(data.sku, organization)

  const images = product.data.images.filter(image => image.main)

  return images[0].sizes[0].url
}

const addImagesInOrderItems = async (orderItems, data, organization) => {
  for (let index = 0; index < orderItems.length; index++) {
    orderItems[index].image = await getImage({ sku: orderItems[index].sku, ...data }, organization)
  }

  return orderItems
}

const getImage = async (data, organization) => {
  let image = ''
  try {
    image = await getUrlMainImages(data, organization)
  } catch (e) {
    image = require('@/assets/placeholder.jpg')
  }
  return image
}

export {
  addImagesInOrderItems,
  getUrlMainImages
}
